import React, { useEffect, useRef } from 'react';
import { useTheme } from '../../contexts/ThemeContext';
export function WebGLBackground() {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const {
    theme
  } = useTheme();
  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    if (!ctx) return;
    let animationFrameId: number;
    let particles: Array<{
      x: number;
      y: number;
      vx: number;
      vy: number;
      size: number;
      opacity: number;
    }> = [];
    const resizeCanvas = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    };
    const createParticles = () => {
      particles = [];
      const particleCount = Math.floor(canvas.width * canvas.height / 15000);
      for (let i = 0; i < particleCount; i++) {
        particles.push({
          x: Math.random() * canvas.width,
          y: Math.random() * canvas.height,
          vx: (Math.random() - 0.5) * 0.3,
          vy: (Math.random() - 0.5) * 0.3,
          size: Math.random() * 2 + 0.5,
          opacity: Math.random() * 0.5 + 0.1
        });
      }
    };
    const animate = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      particles.forEach((particle, index) => {
        particle.x += particle.vx;
        particle.y += particle.vy;
        if (particle.x < 0 || particle.x > canvas.width) particle.vx *= -1;
        if (particle.y < 0 || particle.y > canvas.height) particle.vy *= -1;
        const gradient = ctx.createRadialGradient(particle.x, particle.y, 0, particle.x, particle.y, particle.size * 2);
        if (theme === 'neon') {
          gradient.addColorStop(0, `rgba(6, 182, 212, ${particle.opacity})`);
          gradient.addColorStop(0.5, `rgba(236, 72, 153, ${particle.opacity * 0.5})`);
          gradient.addColorStop(1, 'rgba(6, 182, 212, 0)');
        } else if (theme === 'light') {
          gradient.addColorStop(0, `rgba(168, 85, 247, ${particle.opacity * 0.3})`);
          gradient.addColorStop(0.5, `rgba(236, 72, 153, ${particle.opacity * 0.2})`);
          gradient.addColorStop(1, 'rgba(168, 85, 247, 0)');
        } else {
          gradient.addColorStop(0, `rgba(168, 85, 247, ${particle.opacity})`);
          gradient.addColorStop(0.5, `rgba(236, 72, 153, ${particle.opacity * 0.5})`);
          gradient.addColorStop(1, 'rgba(168, 85, 247, 0)');
        }
        ctx.fillStyle = gradient;
        ctx.beginPath();
        ctx.arc(particle.x, particle.y, particle.size, 0, Math.PI * 2);
        ctx.fill();
        particles.forEach((otherParticle, otherIndex) => {
          if (index === otherIndex) return;
          const dx = particle.x - otherParticle.x;
          const dy = particle.y - otherParticle.y;
          const distance = Math.sqrt(dx * dx + dy * dy);
          if (distance < 150) {
            ctx.strokeStyle = theme === 'neon' ? `rgba(6, 182, 212, ${(1 - distance / 150) * 0.1})` : `rgba(168, 85, 247, ${(1 - distance / 150) * 0.1})`;
            ctx.lineWidth = 0.5;
            ctx.beginPath();
            ctx.moveTo(particle.x, particle.y);
            ctx.lineTo(otherParticle.x, otherParticle.y);
            ctx.stroke();
          }
        });
      });
      animationFrameId = requestAnimationFrame(animate);
    };
    resizeCanvas();
    createParticles();
    animate();
    window.addEventListener('resize', () => {
      resizeCanvas();
      createParticles();
    });
    return () => {
      cancelAnimationFrame(animationFrameId);
      window.removeEventListener('resize', resizeCanvas);
    };
  }, [theme]);
  return <canvas ref={canvasRef} className="absolute inset-0 pointer-events-none" style={{
    opacity: 0.4
  }} data-id="element-878" />;
}